import axios from "axios";
import config from "@/lib/config";
import { getAuthToken } from "@/lib/authStorage";
import { attachApiHeaders } from "@/lib/attachApiHeaders";

const api = axios.create({
  baseURL: `${config.apiUrl}/tax-profiles`,
});

api.interceptors.request.use(attachApiHeaders);

export const listTaxProfiles = async () => {
  const res = await api.get("/");
  return res.data;
};

export const getTaxProfileQuota = async () => {
  const res = await api.get("/quota");
  return res.data;
};

export const getCurrentTaxProfile = async () => {
  const res = await api.get("/current");
  return res.data;
};

export const createTaxProfile = async (data) => {
  const res = await api.post("/", data);
  return res.data;
};

export const updateTaxProfile = async (id, data) => {
  const res = await api.put(`/${id}`, data);
  return res.data;
};

export const setDefaultTaxProfile = async (id) => {
  const res = await api.post(`/${id}/set-default`);
  return res.data;
};

export const getTaxProfileById = async (id) => {
  const res = await api.get(`/${id}`);
  return res.data;
};

// Admin
export const adminListProfilesByUser = async (userId) => {
  const res = await api.get(`/admin/by-user/${userId}`);
  return res.data;
};

export const adminUpdateProfile = async (id, data) => {
  const res = await api.put(`/admin/${id}`, data);
  return res.data;
};

export const adminResetProfile = async (id, mode) => {
  const res = await api.post(`/admin/${id}/reset`, { mode });
  return res.data;
};

export const adminMoveProfile = async (id, newUserId) => {
  const res = await api.post(`/admin/${id}/move`, { newUserId });
  return res.data;
};

export const adminGetQuota = async (userId) => {
  const res = await axios.get(`${config.apiUrl}/account-quota/admin/${userId}`, {
    headers: { Authorization: `Bearer ${getAuthToken()}` },
  });
  return res.data;
};

export const adminSetQuota = async (userId, allowedProfiles) => {
  const res = await axios.put(
    `${config.apiUrl}/account-quota/admin/${userId}`,
    { allowedProfiles },
    { headers: { Authorization: `Bearer ${getAuthToken()}` } }
  );
  return res.data;
};
